import PropTypes from 'prop-types';

import { SELF_SERVICE_DNR_FLOW_TYPES } from '#client/pages/Subscriptions/utils/selfServiceDnrEligibility';

// Keep CANCEL_FLOW_TYPES limited to flows this route config can render.
export const CANCEL_FLOW_TYPES = {
  TRIAL: SELF_SERVICE_DNR_FLOW_TYPES.TRIAL,
  SUBSCRIPTION: SELF_SERVICE_DNR_FLOW_TYPES.SUBSCRIPTION,
};

export const CANCEL_MESSAGE_IDS_BY_FLOW = {
  [CANCEL_FLOW_TYPES.TRIAL]: {
    headerTitle: 'dashboard.subscriptionCancel.header.title',
    help: 'dashboard.subscriptionCancel.help.message',
    confirmationSubheading: 'dashboard.subscriptionCancel.confirmation.subheading',
    confirmationSubmit: 'dashboard.subscriptionCancel.confirmation.submit',
    dateLabel: 'dashboard.subscriptionCancel.subscription.startDate',
  },
  [CANCEL_FLOW_TYPES.SUBSCRIPTION]: {
    headerTitle: 'dashboard.subscriptionCancel.subscription.header.title',
    help: 'dashboard.subscriptionCancel.subscription.help.message',
    confirmationSubheading: 'dashboard.subscriptionCancel.subscription.confirmation.subheading',
    confirmationSubmit: 'dashboard.subscriptionCancel.subscription.confirmation.submit',
    dateLabel: 'dashboard.subscriptionCancel.subscription.nextPayment',
    dateDescription: 'dashboard.subscriptionCancel.subscription.nextPaymentDescription',
  },
};

export const CANCEL_CLICKSTREAM_EVENTS_BY_FLOW = {
  [CANCEL_FLOW_TYPES.TRIAL]: {
    back: 'cancel_trial_back',
    close: 'cancel_trial_close',
    contactCs: 'cancel_trial_contact_cs',
    confirm: 'cancel_trial_confirm',
    reasonSelected: 'cancel_trial_reason_selected',
    reasonContinue: 'cancel_trial_reason_continue',
    changeReason: 'cancel_trial_change_reason',
    submit: 'cancel_trial_submit',
    success: 'cancel_trial_success',
    error: 'cancel_trial_error',
    returnSubscriptions: 'cancel_trial_return_subscriptions',
    returnDashboard: 'cancel_trial_return_dashboard',
    contactResult: 'cancel_trial_contact_us_result',
  },
  [CANCEL_FLOW_TYPES.SUBSCRIPTION]: {
    back: 'cancel_subscription_back',
    close: 'cancel_subscription_close',
    contactCs: 'cancel_subscription_contact_cs',
    confirm: 'cancel_subscription_confirm',
    reasonSelected: 'cancel_subscription_reason_selected',
    reasonContinue: 'cancel_subscription_reason_continue',
    changeReason: 'cancel_subscription_change_reason',
    submit: 'cancel_subscription_submit',
    success: 'cancel_subscription_success',
    error: 'cancel_subscription_error',
    returnSubscriptions: 'cancel_subscription_return_subscriptions',
    returnDashboard: 'cancel_subscription_return_dashboard',
    contactResult: 'cancel_subscription_contact_us_result',
  },
};

function getCancelEventName(cancelFlowType, eventKey) {
  const eventName = CANCEL_CLICKSTREAM_EVENTS_BY_FLOW[cancelFlowType]?.[eventKey];

  if (!eventName) {
    throw new Error(`Unknown subscription cancel event: ${cancelFlowType}.${eventKey}`);
  }

  return eventName;
}

export const subscriptionContextPropType = PropTypes.shape({
  service: PropTypes.string,
  billingInterval: PropTypes.string,
  contractInterval: PropTypes.string,
  subscriptionStatus: PropTypes.string,
});

export function buildSubscriptionContext(subscription) {
  if (!subscription) {
    return undefined;
  }
  return {
    service: subscription.service,
    billingInterval: subscription.period,
    contractInterval: subscription.contractInterval,
    subscriptionStatus: subscription.subscriptionStatus,
  };
}

export function getCancelClickstreamProps(cancelFlowType, eventKey, subscriptionContext) {
  const { service, billingInterval, contractInterval, subscriptionStatus } = subscriptionContext ?? {};
  const dynamic = {
    ...(service && { subscriptionService: service }),
    ...(billingInterval && { billingInterval }),
    ...(contractInterval && { contractInterval }),
    ...(subscriptionStatus && { subscriptionStatus }),
  };
  return {
    elementName: getCancelEventName(cancelFlowType, eventKey),
    ...(Object.keys(dynamic).length > 0 && { dynamicProperties: dynamic }),
  };
}

export function getCancelMessageId(cancelFlowType, messageKey) {
  const messageId = CANCEL_MESSAGE_IDS_BY_FLOW[cancelFlowType]?.[messageKey];

  if (!messageId) {
    throw new Error(`Unknown subscription cancel message: ${cancelFlowType}.${messageKey}`);
  }

  return messageId;
}
